"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCurrentLocation = void 0;
const React = require("react");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const context_1 = require("../../handlers/CustomerLocationHandler/context");
const Icon_1 = require("../../../../../components/base/atoms/Icon");
const colors_1 = require("../../../../../types/colors");
const SetLocationModal_1 = require("../../modals/SetLocationModal");
const useConfig_1 = require("../../../../../hooks/useConfig");
const geoCode_1 = require("../../../../../helpers/geoCode");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CustomerCurrentLocation");
const CustomerCurrentLocation = ({ customerLocation, setCustomerLocation, clearRestaurantOnChange = false, onLocationChange }) => {
    const { googleApiKey } = (0, useConfig_1.useConfig)();
    const retrieveFunc = (0, geoCode_1.retrieveAddressDetailsFromLatLng)(googleApiKey);
    const { completedInitialLocationRetrieval } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const [showUpdateLocationModal, setShowUpdateLocationModal] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!completedInitialLocationRetrieval) {
            return;
        }
        if (customerLocation || customerLocation === undefined) {
            return;
        }
        retrieveFunc().then(setCustomerLocation);
    }, [customerLocation, completedInitialLocationRetrieval]);
    return (React.createElement("div", { className: css("") },
        React.createElement("div", { className: css("container") },
            React.createElement(Icon_1.Icon, { className: css("mapMarker"), name: "map-marker", variant: colors_1.TColorVariants.Danger }),
            React.createElement("span", { className: css("currentLocation") }, customerLocation
                ? customerLocation.fullAddress
                : "Please set your location"),
            React.createElement("a", { className: css("changeLocation"), onClick: () => {
                    setShowUpdateLocationModal(true);
                } }, "change")),
        React.createElement(SetLocationModal_1.SetLocationModal, { open: showUpdateLocationModal, setOpen: setShowUpdateLocationModal, customerLocation: customerLocation, setCustomerLocation: setCustomerLocation, clearRestaurantOnChange: clearRestaurantOnChange, onLocationChange: onLocationChange })));
};
exports.CustomerCurrentLocation = CustomerCurrentLocation;
//# sourceMappingURL=index.js.map